import React from 'react';

import TextFiled from '@atlaskit/textfield';

const FilterInput = ({ setQuery }) => {
  return <TextFiled width="medium" isCompact placeholder="Filter rules by name..." onChange={e => setQuery(e.target.value)}/>;
};

export default FilterInput;

